import { useEffect, useState } from 'react'
import styles from './contactus.module.css'

import constants from '../../../constants.js';
import api from '../../../routes/api.js';

import { useSidebarProvider } from '../../../providers/SidebarProvider.js';
import { useApiProvider } from '../../../providers/ApiProvider.js';


const ContactUs = ({setSelectedMenuItem}) => {
  const { setIsSidebarShowing } = useSidebarProvider();
  const { setDialog, isLoading, setIsLoading, LoadingSpinner } = useApiProvider();

  const [generalState, setGeneralState] = useState({
    firstName: "",
    lastName: "",
    email: "",
    location: "",
    message: "",
  });
  const [clubState, setClubState] = useState({
    firstName: "",
    lastName: "",
    clubName: "",
    email: "",
    location: "",
    message: "",
  });

  const onGeneralChange = (e) => {
    const { name, value } = e.target;
    setGeneralState((prev) => ({ ...prev, [name]: value }));
  };
  const onClubChange = (e) => {
    const { name, value } = e.target;
    setClubState((prev) => ({ ...prev, [name]: value }));
  };

  const submit = async (formType) => {
    setIsLoading(true);
    const request = formType === "general" ? generalState : clubState;
    try {
    
      const resp = await api.post("", constants.uri.contactUs, JSON.stringify(request));
      if (resp.error) throw resp;

      setDialog({
        title: "Success", 
        code: '200', 
        message: "Thank you, we will contact you shortly.", 
        isError: false});
      
      setIsLoading(false);
    } 
    catch (err) {
      console.error(err);
      setDialog({
        title: err.title ? err.title : constants.messages.errorMessage, 
        code: err.status ? err.status : "N/A", 
        message: err.message, 
        isError: true});
      setIsLoading(false);
    }      
  }

  useEffect(() => {
    // If the page is loading on a small width, hide the sidebar so you see the page
    if (window.innerWidth < 1300){
      setIsSidebarShowing(false);
    }
    setSelectedMenuItem("");
  },[]);

  return (
    <div className={styles.ContactUs} style={{backgroundImage: `url(pictures/ContactUs/CPL-Finals-4.5-8.jpg)`}}>
        <div className={styles.Title}>Contact Us</div>
        {!isLoading ? <div className={styles.Container}>

          <form className={styles.Content}>
            <div className={styles.SubTitle}>General Inquiries</div>

            <div className={styles.Row}>
              <div className={styles.Group}>
                <label className={styles.Label}>First Name</label>
                <input 
                  className={styles.Input} 
                  type="text" 
                  placeholder="First Name"
                  name="firstName"
                  value={generalState.firstName}
                  onChange={onGeneralChange}/>
              </div>
              <div className={styles.Group}>
                <label className={styles.Label}>Last Name</label>
                <input 
                  className={styles.Input} 
                  type="text" 
                  placeholder="Last Name"
                  name="lastName"
                  value={generalState.lastName}
                  onChange={onGeneralChange}/>
              </div>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Email Address</label>
              <input 
                className={styles.Input} 
                type="email" 
                placeholder="hello@cpl.com"
                name="email"
                value={generalState.email}
                onChange={onGeneralChange}/>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Location</label>
              <input 
                className={styles.Input} 
                type="text" 
                placeholder="Address"
                name="location"
                value={generalState.location}
                onChange={onGeneralChange}/>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Message</label>
              <textarea 
                style={{height: '15em', fontFamily: 'Montserrat'}} 
                placeholder="Message"
                name="message"
                value={generalState.message}
                onChange={onGeneralChange}/>
            </div>

            <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <button onClick={() => submit(constants.general)} type="submit" className={styles.Button}>Send</button>
            </div>
          </form>

          <form className={styles.Content}>
            <div className={styles.SubTitle}>Club Inquiries</div>

            <div className={styles.Row}>
              <div className={styles.Group}>
                <label className={styles.Label}>First Name</label>
                <input 
                  className={styles.Input} 
                  type="text" 
                  placeholder="First Name"
                  name="firstName"
                  value={clubState.firstName}
                  onChange={onClubChange}/>
              </div>
              <div className={styles.Group}>
                <label className={styles.Label}>Last Name</label>
                <input 
                  className={styles.Input} 
                  type="text" 
                  placeholder="Last Name"
                  name="lastName"
                  value={clubState.lastName}
                  onChange={onClubChange}/>
              </div>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Club Name</label>
              <input 
                className={styles.Input} 
                type="text" 
                placeholder="Club Name"
                name="clubName"
                value={clubState.clubName}
                onChange={onClubChange}/>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Email Address</label>
              <input 
                className={styles.Input} 
                type="email" 
                placeholder="hello@cpl.com"
                name="email"
                value={clubState.email}
                onChange={onClubChange}/>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Location</label>
              <input 
                className={styles.Input} 
                type="text" 
                placeholder="Address"
                name="location"
                value={clubState.location}
                onChange={onClubChange}/>
            </div>

            <div className={styles.Group}>
              <label className={styles.Label}>Message</label>
              <textarea 
                style={{height: '15em', fontFamily: 'Montserrat'}} 
                placeholder="Message"
                name="message"
                value={clubState.message}
                onChange={onClubChange}/>
            </div>

            <div style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
              <button onClick={() => {submit(constants.club)}} type="submit" className={styles.Button}>Send</button>
            </div>
            
          </form>
          
        </div> : <LoadingSpinner/>}
        <br/>
    </div>
  )
}

export default ContactUs;